import { render, staticRenderFns } from "./RincianPajak.vue?vue&type=template&id=2ca57cf0"
import script from "./RincianPajak.vue?vue&type=script&lang=js"
export * from "./RincianPajak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports